<div [class]="card() ? 'card h-100 py-2' : ''">
    @let tmplPlayer = player();
    <div class="d-flex justify-content-center">        
        @if(tmplPlayer){
            <div class="player-img d-flex justify-content-between" [class.w-100]="card()"
                style="background-image: url('{{getPlayerImageUrl(tmplPlayer)}}');">
                @if(player()) {
                    <app-lineicon [line]="tmplPlayer.getLine()"></app-lineicon>
                }
                <div>
                    @if(points() !== undefined) {
                        <span class="badge bg-totals">{{points()}}</span>
                    }
                </div>
            </div>
        }
        @if(!player()) {
            <fa-icon [icon]=faUserCircle size="10x"></fa-icon>
        }
    </div>
    <div class="d-flex justify-content-center mt-1">        
        @if(tmplPlayer){
            @let tmplTeam = tmplPlayer.getTeam();
            @if(tmplTeam){
                <app-team-name [team]="tmplTeam" [fullName]="true"></app-team-name>
            }
        }
    </div>
</div>